@use 'sass:color';
@use '@/sass/variables';
@use '@/sass/utils/mixins';

.ui__banner {
  box-shadow:
    0 0 0 1px rgba(63, 63, 68, 0.05),
    0 1px 3px 0 rgba(63, 63, 68, 0.15);

  &.warning {
    background-color: color.adjust(variables.$yellow, $lightness: 47.5%, $space: hsl);

    .ui__banner__icon {
      background-color: color.adjust(variables.$yellow, $lightness: 40%, $space: hsl);
    }
  }

  &.critical {
    background-color: color.adjust(variables.$red, $lightness: 50%, $space: hsl);

    .ui__banner__icon {
      background-color: color.adjust(variables.$red, $lightness: 45%, $space: hsl);
    }
  }

  &.info {
    background-color: color.adjust(variables.$blue, $lightness: 62.5%, $space: hsl);

    .ui__banner__icon {
      background-color: color.adjust(variables.$blue, $lightness: 57.5%, $space: hsl);
    }
  }

  &.success {
    background-color: color.adjust(variables.$green, $lightness: 62.5%, $space: hsl);

    .ui__banner__icon {
      background-color: color.adjust(variables.$green, $lightness: 57.5%, $space: hsl);
    }
  }
}
